/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import useCliente from "../../hooks/useCliente";
import useLogin from "../../hooks/useLogin";
import ModalAdd from "./Modals/ModalAdd";
import DataTable from "../../components/DataTable/DataTable";
import Title from "../../components/Form/Title";
import ReadOnlyNote from "../../components/Form/ReadOnlyNote";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";

const FORM_VACIO = {
  nombre_comercial: "",
  telefono: "",
  tipo: "",
  RFC: "",
  calle: "",
  exterior: "",
  inerior: "",
  colonia: "",
  municipio: "",
  estado: "",
  cp: "",
  clave: "",
};

export default function Index() {
  const { token, user_rol } = useLogin();
  const dispatch = useDispatch();
  const { loading, error, message, success, Clientes, ClienteGetService, ClienteDeleteService } = useCliente();

  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [form, setform] = useState(FORM_VACIO);

  const puedeEditar = user_rol === "super administrador" || user_rol === "cliente";

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setform(FORM_VACIO);
  };

  useEffect(() => {
    dispatch(setTitle("Descargando Clientes"));
    dispatch(showLoader());
    ClienteGetService(token);
  }, []);

  useEffect(() => {
    if (Clientes.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
  }, [Clientes]);

  useEffect(() => {
    if (success === true) {
      ClienteGetService(token);
    }
  }, [ClienteGetService, success]);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  const editar = (cliente) => {
    setId(cliente.id);
    setUpdate(true);
    setModal(true);
    setform({
      nombre_comercial: cliente.nombre_comercial,
      telefono: cliente.telefono,
      tipo: cliente.tipo,
      RFC: cliente.RFC,
      calle: cliente.calle,
      exterior: cliente.exterior,
      inerior: cliente.inerior,
      colonia: cliente.colonia,
      municipio: cliente.municipio,
      estado: cliente.estado,
      cp: cliente.cp,
      clave: cliente.clave,
    });
  };

  const eliminar = (id) => {
    Swal.fire({
      title: "¿Eliminar cliente?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((resultado) => {
      if (!resultado.isConfirmed) return;

      const data = new FormData();
      data.append("id", id);
      ClienteDeleteService(data, token);

      Swal.fire({
        title: "Espere por favor...",
        text: "Cargando...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        icon: "question",
        didOpen: () => Swal.showLoading(),
      });
    });
  };

  const columnas = useMemo(() => {
    const base = [
      { field: "nombre_comercial", title: "Nombre" },
      { field: "telefono", title: "Telefono" },
      { field: "tipo", title: "Tipo" },
      { field: "RFC", title: "RFC" },
      { field: "calle", title: "Calle" },
      { field: "exterior", title: "Exterior" },
      { field: "inerior", title: "Interior" },
      { field: "colonia", title: "Colonia" },
      { field: "municipio", title: "Municipio" },
      { field: "estado", title: "Estado" },
      { field: "cp", title: "CP" },
      { field: "clave", title: "Clave" },
    ];

    if (!puedeEditar) return base;

    return [
      ...base,
      {
        field: "acciones",
        title: "Acciones",
        sortable: false,
        filterable: false,
        align: "center",
        render: (cliente) => (
          <div className="d-flex gap-2 justify-content-center">
            <button
              className="btn btn-warning btn-sm"
              onClick={() => editar(cliente)}
            >
              Editar
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={() => eliminar(cliente.id)}
            >
              Eliminar
            </button>
          </div>
        ),
      },
    ];
  }, [puedeEditar]);

  return (
    <>
      <ModalAdd
        modal={modal}
        toggle={toggle}
        Update={Update}
        Id={Id}
        token={token}
        ClienteGetService={ClienteGetService}
        form={form}
        setform={setform}
      />

      <div className="container">
        <div className="crud-header">
          <Title title="Listado de Clientes" className="crud-title" />
          {puedeEditar ? (
            <button className="crud-add-btn" onClick={toggle}>
              <i className="bi bi-plus-lg"></i>
              Agregar cliente
            </button>
          ) : (
            <ReadOnlyNote />
          )}
        </div>
        <div className="crud-card">
          <DataTable tableKey="clientes" loading={loading} columns={columnas} data={Clientes} />
        </div>
      </div>
    </>
  );
}
